<div class="container">
  <p class="title">{{ 'symptomAssessment.title_day_picker_step' | translate }}</p>
  <p class="subtitle">{{ 'symptomAssessment.subtitle_day_picker_step' | translate }}</p>
  <div class="days-picker">
    <nz-slider [nzMin]="1" [nzMax]="5" [nzStep]="1" [(ngModel)]="value" [nzMarks]="marks" (ngModelChange)="onSliderChange($event)"></nz-slider>
    <div class="slider-labels">
      @for (mark of markLabels; track mark) {
        <span>{{ mark }}</span>
      }
    </div>
  </div>
</div>
